var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-empty',{attrs:{"image":"/img/NoData.png","image-size":240,"description":"抱歉，鹅宝宝没有找到数据"}})
}
var staticRenderFns = []

export { render, staticRenderFns }